<template>
    <div v-loading="loading" class="margin-top padding-x-y collegeInquire commonBackground">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.title"
                         :name="item.name"
                         v-for="(item,index) in messageList" :key="index">
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="delFloat commonTopMajor">
                <div class="float-left">
                    <span>报考年份：</span>
                    <el-select size="small"
                               @change="selectFirstYear('select')"
                               class="  widthSelect" v-model="yearId"
                               placeholder="请选择">
                        <el-option
                                v-for="item in yearList"
                                :key="item.year"
                                :label="item.text"
                                :value="item.year">
                        </el-option>
                    </el-select>
                </div>
                <div class="float-left">
                    <span class="margin-left">报考科目：</span>
                    <el-select size="small" class="widthSelect margin-right"
                               @change="this.provinceId=''"
                               v-model="wlkFirstId" placeholder="请选择">
                        <el-option
                                v-for="item in wlkFirstList"
                                :key="item.liberalScienceId"
                                :label="item.liberalScienceName"
                                :value="item.liberalScienceId">
                        </el-option>
                    </el-select>
                </div>
                <div class="float-left">
                    <span>报考层次：</span>
                    <el-select size="small" @change="selectLevelFirst('reset')" class="widthSelect  "
                               v-model="levelFirstId" placeholder="请选择">
                        <el-option
                                v-for="item in levelListFirst"
                                :key="item.levelId"
                                :label="item.levelName"
                                :value="item.levelId">
                        </el-option>
                    </el-select>
                </div>
                <div class="float-left">
                    <span class="margin-left">报考批次：</span>
                    <el-select size="small" @change="this.provinceId=''" class="widthSelect  "
                               v-model="batchFirstId" placeholder="请选择">
                        <el-option
                                v-for="item in batchListFirst"
                                :key="item.phaseId"
                                :label="item.phaseName"
                                :value="item.phaseId">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div v-show="activeName==='first'" >
                <div class="margin-medium-top padding-b   commonMajor">
                    <span class="widthTBox  ">院校：</span>
                    <el-autocomplete
                            clearable
                            class="margin-right"
                            style="width:573px;"
                            size="small"
                            prefix-icon="el-icon-search"
                            v-model="universityName"
                            :trigger-on-focus="false"
                            :fetch-suggestions="querySearchAsync"
                            placeholder="请输入学校名称搜索班级"
                            @select="handleSelect">
                    </el-autocomplete>
                    <el-button size="small" type="primary" class="widthBtn"
                         :disabled="universityName===''" @click="searchCollege">
                        查 询
                    </el-button>
<!--                    <el-button v-show="!settingHideLineData" type="text" size="small" @click="settingHideLineData=true">-->
<!--                        <span >按省份浏览院校 <span class="el-icon-arrow-down"></span></span>-->
<!--                    </el-button>-->
<!--                    <el-button v-show="settingHideLineData" type="text" size="small" @click="settingHideLineData=false">-->
<!--                        <span >收起 <span class="el-icon-arrow-up"></span> </span>-->
<!--                    </el-button>-->
                </div>
                <div class="border-bottom margin-top"></div>
<!--                <div v-show="settingHideLineData" >-->
<!--                    <div class="margin-top provinceBox">-->
<!--                        <el-button size="small"-->
<!--                                   v-for="(item,index) in provinceList"-->
<!--                                   style="padding:5px 10px;width:100px;"-->
<!--                                   :key="index"-->
<!--                                   type="text"-->
<!--                                   @click="selectProvinceFirst(item.provinceId)"-->
<!--                                   :title="item.provinceName"-->
<!--                                   :class="provinceId===item.provinceId?'active':''"-->
<!--                                   class="margin-top margin-left text-ellipsis">-->
<!--                            {{item.provinceName}}-->
<!--                        </el-button>-->
<!--                    </div>-->
<!--                    <div class="margin-top collegeBox rounded-small public_scroll_bar">-->
<!--                        <div class="collegeSon margin-top margin-left" v-for="(item,index) in universityDataFirst">-->
<!--                            <el-button size="small"-->
<!--                                       style="padding:5px 10px;"-->
<!--                                       :key="index"-->
<!--                                       :class="universityId===item.universityId?'active':''"-->
<!--                                       :title="item.universityName"-->
<!--                                       @click="selectCollege(item.universityId,item.universityName)"-->
<!--                                       class="butt   ">-->
<!--                                {{item.universityName}}-->
<!--                            </el-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-show="universityData!==''" class="delFloat margin-top">-->
<!--                    <div class="float-left margin-right univerLog">-->
<!--                        <img v-lazy="universityData.logo" width="52" height="52" :key="universityData.logo"  alt="">-->
<!--                    </div>-->
<!--                    <div class="float-left">-->
<!--                        <div class="font-weight-bolder cursorSz" @click="lookUniverSityDetail">{{universityData.name}}</div>-->
<!--                        <div class="margin-top">-->
<!--                            <el-tag effect="light"-->
<!--                                    v-if="universityDataFeature!==''"-->
<!--                                    class="margin-right  rounded-small"-->
<!--                                    size="mini"-->
<!--                                    :key="'ss'+index"-->
<!--                                    v-for="(item,index) in universityDataFeature.split(',')"-->
<!--                                    >-->
<!--                                {{item}}-->
<!--                            </el-tag>-->
<!--                            <el-tag-->
<!--                                    v-if="universityData.cityName"-->
<!--                                    class="margin-right text-white border-0"-->
<!--                                    color="#F5A623"-->
<!--                                    size="mini"-->
<!--                                    effect="light">-->
<!--                                {{universityData.cityName}}-->
<!--                            </el-tag>-->
<!--                            <el-tag-->
<!--                                    v-if="universityDataRanking!==''"-->
<!--                                    class="margin-right text-white border-0"-->
<!--                                    color="#06C05F"-->
<!--                                    size="mini"-->
<!--                                    :key="index"-->
<!--                                    v-for="(item,index) in universityDataRanking.split(',')"-->
<!--                                    effect="light">-->
<!--                                {{item}}-->
<!--                            </el-tag>-->

<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <el-table :data="firstTableData" class="margin-medium-top"
                          :header-cell-style="headerStyleCell" :cell-style="{textAlign:'center'}">
<!--                    当data==1时 为6选3 查询的数据表格只显示 科目要求-->
<!--                    当data==2时 为3+1+2 查询的数据表格只显示 首选科目要求 次选科目要求-->
<!--                    当data==0时 非新高考省份 不显示选科要求的列-->
                    <el-table-column prop="universityName" label="院校名称">
                    </el-table-column>
                    <el-table-column prop="majorName" label="专业名称">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.majorName}}
                                <el-tooltip  effect="light"
                                             v-show="scope.row.memo!==''"
                                             :content="scope.row.memo"
                                             placement="top-start">
                                    <el-button type="text" class="el-icon-question"></el-button>
                                </el-tooltip>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="levelName"
                            label="培养层次">
                    </el-table-column>
                   <el-table-column
                        prop="scorePlace"
                        v-if="selectionMode===1||selectionMode===2"
                        :label="selectionMode===1?'科目要求':'首选科目要求'">
                       <template slot-scope="scope">
                           <div>
                                <div>
                                   {{scope.row.firstSubjectRequire}}
                                </div>
                                <div class="text-medium-secondary"
                                     v-show="scope.row.firstSubjectRequireCode!=='0'">
                                    ({{scope.row.firstSubjectRequireCode}})
                                </div>
                           </div>
                       </template>
                   </el-table-column>
                   <el-table-column
                         prop="scorePlace"
                         v-if="selectionMode===2"
                         label="次选科目要求">
                       <template slot-scope="scope">
                           <div>
                               {{scope.row.secondSubjectRequire}}
                           </div>
                           <div class="text-medium-secondary"
                                v-show="scope.row.secondSubjectRequireCode!=='0'">
                               ({{scope.row.secondSubjectRequireCode}})
                           </div>
                       </template>
                    </el-table-column>
                    <el-table-column prop="enrollPlan" :label="yearId+'招生计划'">
                    </el-table-column>
                   <el-table-column prop="admitNum" :label="yearId+'录取人数'">
                    </el-table-column>
                    <el-table-column prop="lastScorePlace" label="投档位次">
                    </el-table-column>
                    <el-table-column prop="lastScore" label="投档分数">
                    </el-table-column>
<!--                    <el-table-column label="专业录取信息">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button type="text">查看</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
                <el-pagination
                        class="margin-top text-right"
                        :hide-on-single-page="false"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="20"
                        layout="prev, pager, next, jumper"
                        :total="totalItem">
                </el-pagination>
            </div>
            <div v-show="activeName==='second'">
                <div class="commonMajor padding-b  ">
                    <span >位次范围：</span>
                    <el-input size="small" class="widthDuan" v-model="rankingBegin"></el-input> ~
                    <el-input size="small" class="widthDuan" v-model="rankingEnd"></el-input>
                    <el-button size="small" type="primary" class="widthBtn margin-left commonBtnLeft"
                               @click="scoreRankingSearch('reset')"
                               :disabled="rankingEnd===''||rankingBegin===''">
                        查 询
                    </el-button>
                </div>
                <div class="border-bottom margin-top"></div>
                <div class="margin-medium-top" v-show="hideTopTwoBtn">
                    <el-popover
                            ref="provinceSecondTW"
                            placement="bottom"
                            width="400"
                            title="按院校所在地筛选"
                            trigger="click">
                        <div>
                            <el-radio-group class="margin-top" v-model="provinceTId">
                                <el-radio style="width:60px;margin-bottom: 10px;" v-for="item in tableTProvince"

                                          :key="item.provinceId"
                                          :label="item.provinceId">
                                    {{item.provinceName}}
                                </el-radio>
                            </el-radio-group>
                            <div class="margin-top text-right">
                                <el-button size="small" @click="confirmTRegion" type="primary">
                                    确定
                                </el-button>
                            </div>
                        </div>
                        <el-button slot="reference" class=" borderBlue margin-right" size="small">
                            按院校所在地筛选
                        </el-button>
                    </el-popover>
                    <el-popover
                            ref="typeSecondTW"
                            placement="bottom"
                            width="400"
                            title="按院校类型筛选"
                            trigger="click">
                        <div>
                            <el-radio-group class="margin-top" v-model="typeTId">
                                <el-radio style="width:60px;margin-bottom: 10px;" v-for="item in tableTCType"
                                          :key="item.universityTypeId"
                                          :label="item.universityTypeId">
                                    {{item.universityTypeName}}
                                </el-radio>
                            </el-radio-group>
                            <div class="margin-top text-right">
                                <el-button size="small" @click="confirmTRegion" type="primary">
                                    确定
                                </el-button>
                            </div>
                        </div>
                        <el-button slot="reference" class="borderBlue" size="small">
                            按院校类型筛选
                        </el-button>
                    </el-popover>
                </div>
                <el-table :data="secondTableData" :header-cell-style="headerStyleCell"
                          class="margin-medium-top" :cell-style="{textAlign:'center'}">
                    <el-table-column prop="universityName" label="院校名称">
                    </el-table-column>
                    <el-table-column prop="majorName" label="专业名称">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.majorName}}
                                <el-tooltip  effect="light"
                                             v-show="scope.row.memo!==''"
                                             :content="scope.row.memo"
                                             placement="top-start">
                                    <el-button type="text" class="el-icon-question"></el-button>
                                </el-tooltip>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="levelName"
                            label="培养层次">
                    </el-table-column>
                    <el-table-column
                            prop="scorePlace"
                            v-if="selectionMode===1"
                            :label="selectionMode===1?'科目要求':'首选科目要求'">
                        <template slot-scope="scope">
                            <div>
                                <div>
                                    {{scope.row.firstSubjectRequire}}
                                </div>
                                <div class="text-medium-secondary" v-show="scope.row.firstSubjectRequireCode!=='0'">
                                    ({{scope.row.firstSubjectRequireCode}})
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="scorePlace"
                            v-if="selectionMode===2"
                            label="次选科目要求">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.secondSubjectRequire}}
                            </div>
                            <div class="text-medium-secondary" v-show="scope.row.secondSubjectRequireCode!=='0'">
                                ({{scope.row.secondSubjectRequireCode}})
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="enrollPlan" :label="yearId+'招生计划'">
                    </el-table-column>
                    <el-table-column prop="admitNum" :label="yearId+'录取人数'">
                    </el-table-column>
                    <el-table-column prop="lastScorePlace" label="投档位次">
                    </el-table-column>
                    <el-table-column prop="lastScore" label="投档分数">
                    </el-table-column>
<!--                    <el-table-column label="专业录取信息">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button type="text">查看</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
                <el-pagination
                        class="margin-top text-right"
                        :hide-on-single-page="false"
                        @current-change="handleCurrentSecondChange"
                        :current-page.sync="currentTwoPage"
                        :page-size="20"
                        layout="prev, pager, next, jumper"
                        :total="totalItemSecond">
                </el-pagination>
            </div>
            <div v-show="activeName==='third'">
                <div class="commonMajor   padding-b">
                    <span>分数范围：</span>
                    <el-input size="small" class="widthDuan" v-model="scoreBegin"></el-input> ~
                    <el-input size="small" class="widthDuan" v-model="scoreEnd"></el-input>
                    <el-button size="small" type="primary" class="widthBtn margin-left commonBtnLeft"
                               @click="scoreSearch('reset')"
                               :disabled="scoreBegin===''||scoreEnd===''">
                        查 询
                    </el-button>
                </div>
                <div class="border-bottom margin-top"></div>
                <div class="margin-medium-top" v-show="hideThirdTwoBtn">
                    <el-popover
                            ref="provinceTW"
                            placement="bottom"
                            width="400"
                            title="按院校所在地筛选"
                            trigger="click">
                        <div>
                            <el-radio-group class="margin-top" v-model="provinceTIdScore">
                                <el-radio style="width:60px;margin-bottom: 10px;" v-for="item in tableTProvince"
                                          :key="item.provinceId"
                                          :label="item.provinceId">
                                    {{item.provinceName}}
                                </el-radio>
                            </el-radio-group>
                            <div class="margin-top text-right">
                                <el-button size="small" @click="confirmTRegionThird" type="primary">
                                    确定
                                </el-button>
                            </div>
                        </div>
                        <el-button slot="reference" class=" borderBlue margin-right" size="small">
                            按院校所在地筛选
                        </el-button>
                    </el-popover>
                    <el-popover
                            ref="typeTW"
                            placement="bottom"
                            width="400"
                            title="按院校类型筛选"
                            trigger="click">
                        <div>
                            <el-radio-group class="margin-top" v-model="typeTIdScore">
                                <el-radio style="width:60px;margin-bottom: 10px;" v-for="item in tableTCType"
                                          :key="item.universityTypeId"
                                          :label="item.universityTypeId">
                                    {{item.universityTypeName}}
                                </el-radio>
                            </el-radio-group>
                            <div class="margin-top text-right">
                                <el-button size="small" @click="confirmTRegionThird" type="primary">
                                    确定
                                </el-button>
                            </div>
                        </div>
                        <el-button slot="reference" class="borderBlue" size="small">
                            按院校类型筛选
                        </el-button>
                    </el-popover>
                </div>
                <el-table :data="scoreTableData" class="margin-medium-top"
                          :header-cell-style="headerStyleCell" :cell-style="{textAlign:'center'}">
                    <el-table-column prop="universityName" label="院校名称">
                    </el-table-column>
                    <el-table-column prop="majorName" label="专业名称">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.majorName}}
                                <el-tooltip  effect="light"
                                             v-show="scope.row.memo!==''"
                                             :content="scope.row.memo"
                                             placement="top-start">
                                    <el-button type="text" class="el-icon-question"></el-button>
                                </el-tooltip>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="levelName"
                            label="培养层次">
                    </el-table-column>
                    <el-table-column
                            prop="scorePlace"
                            v-if="selectionMode===1"
                            :label="selectionMode===1?'科目要求':'首选科目要求'">
                        <template slot-scope="scope">
                            <div>
                                <div>
                                    {{scope.row.firstSubjectRequire}}
                                </div>
                                <div class="text-medium-secondary" v-show="scope.row.firstSubjectRequireCode!=='0'">
                                    ({{scope.row.firstSubjectRequireCode}})
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="scorePlace"
                            v-if="selectionMode===2"
                            label="次选科目要求">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.secondSubjectRequire}}
                            </div>
                            <div class="text-medium-secondary" v-show="scope.row.secondSubjectRequireCode!=='0'">
                                ({{scope.row.secondSubjectRequireCode}})
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="enrollPlan" :label="yearId+'招生计划'">
                    </el-table-column>
                    <el-table-column prop="admitNum" :label="yearId+'录取人数'">
                    </el-table-column>
                    <el-table-column prop="lastScorePlace" label="投档位次">
                    </el-table-column>
                    <el-table-column prop="lastScore" label="投档分数">
                    </el-table-column>
<!--                    <el-table-column label="专业录取信息">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button type="text">查看</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
                <el-pagination
                        class="margin-top text-right"
                        :hide-on-single-page="false"
                        @current-change="handleCurrentThirdChange"
                        :current-page.sync="currentThirdPage"
                        :page-size="20"
                        layout="prev, pager, next, jumper"
                        :total="totalItemThird">
                </el-pagination>
            </div>
            <div v-show="activeName==='four'">
                <div class="commonMajor   padding-b">
                    <span>专业名称：</span>
                    <el-input v-model="majorName"
                              clearable
                              class="margin-right"
                              style="width:573px;"
                              size="small"
                              prefix-icon="el-icon-search"
                    ></el-input>
                    <el-button size="small" type="primary" class="widthBtn    "
                               @click="majorNameSearch('reset')"
                               :disabled="majorName===''">
                        查 询
                    </el-button>
                </div>
                <el-table :data="fourTableDataList" class="margin-medium-top"
                          :header-cell-style="headerStyleCell"
                          :cell-style="{textAlign:'center'}">
                    <el-table-column prop="universityName" label="院校名称">
                    </el-table-column>
                    <el-table-column prop="majorName" label="专业名称">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.majorName}}
                                <el-tooltip  effect="light"
                                             v-show="scope.row.memo!==''"
                                             :content="scope.row.memo"
                                             placement="top-start">
                                    <el-button type="text" class="el-icon-question"></el-button>
                                </el-tooltip>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="levelName"
                            label="培养层次">
                    </el-table-column>
                    <el-table-column
                            prop="scorePlace"
                            v-if="selectionMode===1"
                            :label="selectionMode===1?'科目要求':'首选科目要求'">
                        <template slot-scope="scope">
                            <div>
                                <div>
                                    {{scope.row.firstSubjectRequire}}
                                </div>
                                <div class="text-medium-secondary" v-show="scope.row.firstSubjectRequireCode!=='0'">
                                    ({{scope.row.firstSubjectRequireCode}})
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="scorePlace"
                            v-if="selectionMode===2"
                            label="次选科目要求">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.secondSubjectRequire}}
                            </div>
                            <div class="text-medium-secondary" v-show="scope.row.secondSubjectRequireCode!=='0'">
                                ({{scope.row.secondSubjectRequireCode}})
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="enrollPlan" :label="yearId+'招生计划'">
                    </el-table-column>
                    <el-table-column prop="admitNum" :label="yearId+'录取人数'">
                    </el-table-column>
                    <el-table-column prop="lastScorePlace" label="投档位次">
                    </el-table-column>
                    <el-table-column prop="lastScore" label="投档分数">
                    </el-table-column>
<!--                    <el-table-column label="专业录取信息">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button type="text">查看</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
                <el-pagination
                        class="margin-top text-right"
                        :hide-on-single-page="false"
                        @current-change="handleCurrentFourChange"
                        :current-page.sync="currentFourPage"
                        :page-size="20"
                        layout="prev, pager, next, jumper"
                        :total="totalFourItem">
                </el-pagination>
            </div>
            </div>
        <common-target-router @clearHref="clearHref"
                              :getLocation="getLocation">
        </common-target-router>

    </div>
</template>
<script>
    import {
        collegeBaseInfo,
        provinces,
        queryCollegeGetCollege,
        queryCollegeGetLastScorePlace,queryMajorGetCollege,
        queryMajorGetLevel,
        queryMajorGetLiberalScience, queryMajorGetList, queryMajorGetPhase,
        queryMajorGetYears, queryMajorIsNewGk,
        tableProvince,
        tableUniType
    } from "../../../config";

    import {message} from 'element-ui'
    export default {
        name: "queryByMajor",

        data(){
            return{
                getLocation:'',
                universityDataFeature:'',
                universityDataRanking:'',
                //获取大学Id
                universityOptionId:'',
                universityData:'',
                //获取选科模式
                selectionMode:'',
                headerStyleCell:{
                    backgroundColor:'rgba(0,0,0,0.02)',
                    textAlign:'center'
                },
                firstTableData:[],
                universityName:'',
                loading:false,
                activeName:'first',
                //报考年份
                yearList:[],
                yearId:'',
                wlkFirstList:[],
                wlkFirstId:'',
                levelFirstId:'',
                levelListFirst:[],
                batchListFirst:[],
                batchFirstId:'',
                provinceList:[],
                provinceId:'',
                universityDataFirst:[],
                universityId:'',
                currentPage:1,
                totalItem:0,
                //设置隐藏底部两行选项
                settingHideLineData:false,
                messageList:[
                    {
                        name:'first',
                        title:'按院校名称查询'
                    },
                    {
                        name:'second',
                        title:'按分位次查询'
                    },
                    {
                        name:'third',
                        title:'按投档分查询'
                    },

                    {
                        name:'four',
                        title:'按专业名称查询'
                    }
                ],
                /*********second分位次查询***********/
                //隐藏second,table上两个按钮
                hideTopTwoBtn:false,
                rankingBegin:'',
                rankingEnd:'',
                secondTableData:[],
                totalItemSecond:0,
                currentTwoPage:1,
                tableTCType:[],
                tableTProvince:[],
                //表格上方院校地区id
                provinceTId:'',
                typeTId:'',
                scoreBegin:'',
                scoreEnd:'',
                /******分数查询******/
                hideThirdTwoBtn:false,
                currentThirdPage:1,
                totalItemThird:0,
                scoreTableData:[],
                provinceTIdScore:'',
                typeTIdScore:'',
                /******专业名称查询******/
                currentFourPage:1,
                majorName:'',
                totalFourItem:0,
                fourTableDataList:[]
            }
        },
        mounted(){
            this.loading=true;
            this.getYearList();
            this.searchProvinces();
            this.collegeProvinceOption();
            this.collegeTypeOption();
        },
        methods:{
            lookUniverSityDetail(){
                const {href} = this.$router.resolve(
                    {path:'/sall/collegeDetail',query:{univerSityId:this.universityId}});
                this.getLocation=href;
            },
            clearHref(){
                this.getLocation='';
            },
            //根据大学ID查询大学的基础信息
            async collegeBaseInfo(){
                let result=await collegeBaseInfo(this.universityId);
                if(result.status){
                    this.universityData=result.data;
                    this.universityDataFeature=result.data.feature;
                    this.universityDataRanking=result.data.rank;
                    // "id": "8ef9855cde4a9aaa7afc958fdc631612",
                    //     "name": "山东大学",
                    //     "logo": "//file.imcdn.com/pic/5948cbfc5b935.jpg",
                    //     "feature": "211,985,双,研,公,综,强基计划",
                    //     "buildTypeName": "公办",
                    //     "universityTypeName": "综合",
                    //     "campusTypeName": "大学",
                    //     "levelName": "本科",
                    //     "rank": "全国:13,综合:9",
                    //     "belongTo": "教育部",
                    //     "provinceName": "山东省",
                    //     "cityName": "济南市",
                    //     "foundingYear": "1901",
                    //     "address": "山东省济南市山大南路27号",
                    //     "studentNum": "5万人以上",
                    //     "academicianNum": "9人",
                    //     "masterNum": "310个",
                    //     "doctorNum": "230个",
                    //     "webSite": "http://www.sdu.edu.cn/",
                    //     "enWebsite": "http://www.bkzs.sdu.edu.cn/",
                    //     "hasFaved": 0
                }
            },
            //当data==1时 为6选3 查询的数据表格只显示 科目要求
            //当data==2时 为3+1+2 查询的数据表格只显示 首选科目要求 次选科目要求
            // 当data==0时 非新高考省份 不显示选科要求的列
            //根据当前登录人获取选科模式
            async queryMajorIsNewGk(){
                let result =await queryMajorIsNewGk(this.yearId);
                if(result.status){
                    this.selectionMode=result.data.gkType;
                }
            },
            //切换分页
            handleCurrentChange(){
                this.queryCollegeGetScoreData();
            },
            //选择省份
            selectProvinceFirst(val){
                this.provinceId=val;
                this.queryCollegeGetCollege('flag');
            },
            //选择年份
            selectFirstYear(val){
                this.provinceId='';
                this.queryCollegeGetLiberalScience(val);

            },
            //选择报考层次
            selectLevelFirst(){
                this.provinceId='';
                this.queryCollegeGetPhase('reset');
            },
            //选择院校
            selectCollege(val,name){
                this.universityName=name;
                this.universityId=val;
                this.queryCollegeGetScoreData();
            },
            //获取年份
            async getYearList(){
                let result=await queryMajorGetYears();
                if(result.status){
                    this.yearList=result.data;
                    this.yearId=result.data[0].year;
                    this.queryCollegeGetLiberalScience();
                    //获取选科模式
                    this.queryMajorIsNewGk();
                }
            },
            //文本框输入内容搜索院校查询相关
            async querySearchAsync(queryString, cb){
                let result=await queryMajorGetCollege(this.yearId,this.levelFirstId,'',this.wlkFirstId,this.batchFirstId,this.universityName);
                if(result.status){
                    let zhi=[];
                    result.data.forEach((val)=>{
                        zhi.push({
                            value:val.universityName,
                            address:val.universityId
                        })
                    });
                    var results = queryString ? zhi.filter(this.createStateFilter(queryString)) : zhi;
                    cb(results);
                }
            },
            //选择所匹配的内容，查出相关班级
            handleSelect(val){
                this.universityId=val.address;
                this.searchCollege();
            },
            //文本框输入内容搜索院校查询相关
            createStateFilter(queryString){
                return (state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            //获取文理科
            async queryCollegeGetLiberalScience(val){
                let result=await queryMajorGetLiberalScience(this.yearId);
                if(result.status){
                    this.loading=false;
                    this.wlkFirstList=result.data;
                    this.wlkFirstId=result.data[0].liberalScienceId;
                    this.queryCollegeGetLevel(val);
                }
            },
            //根据省份年份获取报考层次
            async queryCollegeGetLevel(val){
                let result=await queryMajorGetLevel(this.yearId);
                if(result.status){
                    this.levelListFirst=result.data;
                    this.levelFirstId=result.data[0].levelId;
                    this.queryCollegeGetPhase(val);
                }
            },
            //根据用户省份年份层次获取报考批次
            async queryCollegeGetPhase(val){
                let result=await queryMajorGetPhase(this.yearId,this.levelFirstId);
                if(result.status){
                    this.batchListFirst=result.data;
                    this.batchFirstId=result.data[0].phaseId;
                    //查出默认条件根据默认条件查出分位次Table，分数Table
                    this.defaultTableContent();
                    if(!val) {
                        this.queryCollegeGetCollege(val);
                    }
                }
            },
            //列出所有省份
            async searchProvinces(){
                let result=await provinces();
                if(result.status){
                    this.provinceList=result.data;
                    this.provinceId=result.data[0].provinceId;
                }
            },
            //查出院校选项
            async queryCollegeGetCollege(){
                let result=await queryMajorGetCollege(this.yearId,this.levelFirstId,this.provinceId,this.wlkFirstId,this.batchFirstId);
                if(result.status){
                    this.universityDataFirst=result.data;
                    this.universityId=result.data[0].universityId;
                    this.universityName=result.data[0].universityName;
                    this.queryCollegeGetScoreData();
                }
            },
            //查出院校
            searchCollege(){
                this.currentPage=1;
                this.settingHideLineData=false;
                this.queryCollegeGetScoreData();

            },
            //按院校名称查出院校查询相关的表格内容
            async queryCollegeGetScoreData(){
                let result=await queryMajorGetList(this.yearId,this.levelFirstId,this.batchFirstId,this.wlkFirstId,[],[],this.universityName,'','','',this.currentPage,20);
                if(result.status){
                    this.collegeBaseInfo();
                    this.firstTableData=result.data.data;
                    this.totalItem=result.data.totalRecords;
                }
            },
            //进入分位次查询或者分数查询默认显示表格内容
            async defaultTableContent(){
                let result=await queryCollegeGetLastScorePlace(this.yearId,this.wlkFirstId);
                if(result.status){
                    this.rankingBegin=result.data.positionRanges[0];
                    this.rankingEnd=result.data.positionRanges[1];
                    this.scoreBegin=result.data.scoreRanges[0];
                    this.scoreEnd=result.data.scoreRanges[1];
                    this.majorName='计算机';
                    //默认查出分位次相关的table内容
                    this.scoreRankingSearch();
                    //默认查出分数相关的table内容
                    this.scoreSearch();
                    //默认根据专业名称查出内容
                    this.majorNameSearch();
                }
            },
            /*******按分位次查询相关********/
            //确定选择区域
            confirmTRegion(){
                this.$refs['provinceSecondTW'].doClose();
                this.$refs['typeSecondTW'].doClose();
                this.scoreRankingSearch();

            },
            //查出分位次表格上方的院校所在地选项
            async collegeProvinceOption(){
                let result=await tableProvince();
                if(result.status){
                    this.tableTProvince=result.data;
                    this.provinceTId=result.data[0].provinceId;

                    this.provinceTIdScore=result.data[0].provinceId;
                }
            },
            //查出表格上方的院校类型
            async collegeTypeOption(){
                let result=await tableUniType();
                if(result.status){
                    this.tableTCType=result.data;
                    this.typeTId=result.data[0].universityTypeId;
                    this.typeTIdScore=result.data[0].universityTypeId;
                }
            },
            //按分位次查询
            async scoreRankingSearch(val){
                if(val){
                    this.currentTwoPage=1;
                }
                this.hideTopTwoBtn=false;
                if(this.rankingBegin===''||this.rankingEnd===''){
                    message({
                        message:'请输入位次范围',
                        type:'warning',
                        offset:300,
                        duration:800
                    })
                    return false;
                }else if(isNaN(this.rankingBegin)||isNaN(this.rankingEnd)){
                    message({
                        message:'位次范围格式错误',
                        type:'warning',
                        offset:300,
                        duration:800
                    })
                    return false;
                }
                let result=await queryMajorGetList(this.yearId,this.levelFirstId,
                    this.batchFirstId,this.wlkFirstId,[Number(this.rankingBegin),Number(this.rankingEnd)],[],'','',
                    this.provinceTId,this.typeTId,this.currentTwoPage,20);
                if(result.status){
                    this.hideTopTwoBtn=true;
                    this.secondTableData=result.data.data;
                    this.totalItemSecond=result.data.totalRecords;
                }else{
                    this.hideTopTwoBtn=false;
                }
            },
            handleCurrentSecondChange(){
                this.scoreRankingSearch();
            },
            changeTab(val){
                this.activeName=val;

            },
            //切换tabs
            handleClick(){

            },
            /*****按分数查询******/
            confirmTRegionThird(){
                this.$refs['typeTW'].doClose();
                this.$refs['provinceTW'].doClose();
                this.scoreSearch();
            },
            handleCurrentFourChange(){
                this.majorNameSearch();
            },
            //专业名称查询
            async majorNameSearch(val){
                if(val){
                    this.currentFourPage=1;
                }
                if(this.majorName===''){
                    message({
                        message:'请输入专业名称',
                        type:'warning',
                        offset:300,
                        duration:800
                    })
                    return false;
                }
                let result=await queryMajorGetList(this.yearId,this.levelFirstId,
                    this.batchFirstId,this.wlkFirstId,[],[],'',this.majorName,'','',this.currentFourPage,20);
                if(result.status){
                    this.fourTableDataList=result.data.data;
                    this.totalFourItem=result.data.totalRecords;
                }
            },
            //分数查询
            async scoreSearch(val){
                if(val){
                    this.currentThirdPage=1;
                }
                this.hideThirdTwoBtn=false;
                if(this.scoreBegin===''||this.scoreEnd===''){
                    message({
                        message:'请输入分数范围',
                        type:'warning',
                        offset:300,
                        duration:800
                    })
                    return false;
                }else if(isNaN(this.scoreBegin)||isNaN(this.scoreEnd)){
                    message({
                        message:'分数范围格式错误',
                        type:'warning',
                        offset:300,
                        duration:800
                    })
                    return false;
                }
                let result=await queryMajorGetList(this.yearId,this.levelFirstId,
                    this.batchFirstId,this.wlkFirstId,[],[Number(this.scoreBegin),
                        Number(this.scoreEnd)],'','',this.provinceTIdScore,
                        this.typeTIdScore,this.currentThirdPage,20);
                if(result.status){
                    this.hideThirdTwoBtn=true;
                    this.scoreTableData=result.data.data;
                    this.totalItemThird=result.data.totalRecords;
                }
            },
            handleCurrentThirdChange(){
                this.scoreSearch();
            }
        }
    }
</script>
<style lang="scss">
    .collegeInquire{
        .el-table td,.el-table th.is-leaf {
            border-bottom: 1px dashed #e5e5e5;

        }
        .el-table--border th,.el-table--border th.gutter:last-of-type {
            border-bottom: 1px dashed #e5e5e5;

        }
    }
</style>
<style lang="scss" scoped>
    .collegeInquire{
        min-height:300px;

    }
    .univerLog{
        margin-top:6px;
    }
    .marginR{
        margin-right:100px;
    }
    .widthBtn{
        width:150px;
        padding:6px;
        font-size: 16px;
    }
    .widthSelect{
        width:120px;
    }
    .provinceBox{
        padding-bottom: 20px;
        border-bottom: 1px dashed #e5e5e5;
    }
    .collegeBox{
        background:#e5e5e5;
        height:300px;
        .collegeSon{
            display: inline-block;
            width:300px;
        }
    }
    .widthDuan{
        width:173px;
    }
    .borderBlue{
        border: 1px solid dodgerblue;
        color:dodgerblue;
    }
    .widthTBox{
        width:69px;
        display: inline-block;
    }
    //将上方文本框居中
    .topInputCenter{
        text-align: left;
        width: 912px;
        margin: 20px auto;
    }
    .commonLeft{
        margin-left: 66px;
    }
    .commonBtnLeft{
        margin-left: 223px!important;
    }
    .commonMajor{
        width: 821px;
        margin: 32px auto 0 auto;
    }
    .commonTopMajor{
        width: 821px;
        margin: 0 auto  ;
    }
</style>